import React, { useMemo } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useCreateCustomerMutation } from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { ICustomer } from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";

  interface ITaxpopup {
    openModel?: boolean;
    handleCloseDialog: (close: boolean) => void;
    data?: ICustomer;
    onSuccess?: (newCustomer: any) => void;   
  }

  const Customer = ({ openModel = false, handleCloseDialog, data, onSuccess  }: ITaxpopup) => {
    const classes = useStyles();
    const theme = useTheme();
    const [open] = React.useState(openModel);
    const [newCustomer, { isLoading }] = useCreateCustomerMutation();
    const { showErrorMessage, showMessage } = useNotifier();
    const handleClose = () => {
      handleCloseDialog(false);
    };

    const validateEmail = (value: string) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    };

    const formik = useFormik({
      initialValues: {
        id: data?.id,
        customerFirstName: data?.customerFirstName,
        customerLastName: data?.customerLastName,
        customerMobileNum: data?.customerMobileNum,
        customerEmail: data?.customerEmail,
    
        customerProvince: data?.customerProvince || "",
        customerCity: data?.customerCity || "",
        customerPostalCode: data?.customerPostalCode || "",
        customerStreetNumber: data?.customerStreetNumber || "",
        customerStreetName: data?.customerStreetName || "",

        customerDescription: data?.customerDescription,

        customerCompanyName: data?.customerCompanyName || "",
        customerCompanyPhoneNumebr: data?.customerCompanyPhoneNumebr || "",
        customerCompanyEmail: data?.customerCompanyEmail || "",
      },

        enableReinitialize: true,
          validate: (values) => {
            const errors: { [key: string]: string } = {};
      
     
         if (!values.customerFirstName) errors.customerFirstName = "Name is required";
       
            return errors;
          },
      onSubmit: async (values) => {
        try {

          // if (!validateEmail(values.customerEmail || '')) {
          //   showErrorMessage('Please enter a valid email address.');
          //   return;
          // }


          const temData = {
            id: values?.id,
            customerFirstName: values.customerFirstName,
            customerLastName: values.customerLastName,
            customerMobileNum: values.customerMobileNum,
            customerEmail: values.customerEmail,
          
            customerProvince: values.customerProvince,
            customerCity: values.customerCity,
            customerPostalCode: values.customerPostalCode,
            customerStreetNumber: values.customerStreetNumber,
            customerStreetName: values.customerStreetName,

            customerDescription: values.customerDescription,

            customerCompanyName: values.customerCompanyName,
            customerCompanyPhoneNumebr: values.customerCompanyPhoneNumebr,
            customerCompanyEmail: values.customerCompanyEmail,
          };
          if (!data) {
            delete values.id;
          }

          const addCompanyResponse = await newCustomer(temData).unwrap();
          if (!addCompanyResponse.status) {
            showErrorMessage(addCompanyResponse.message);
          } else {
            showMessage(addCompanyResponse.message);
          onSuccess && onSuccess(addCompanyResponse.data);
          handleClose();
          
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.customerFirstName === "" ||
      formik.values.customerFirstName === undefined
      ? false
      : true;
  }, [formik]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Dialog open={open}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
             <Card className={classes.stepperCard}>
              <Grid container justifyContent="space-between">
                 <Grid
                                   container
                                   justifyContent={"space-between"}
                                   spacing={5}
                                   sx={{ borderBottom: 2, padding: 2 }}
                                   className={classes.titleGrid}
                                 >
                                   <Grid
                                     item
                                     lg={12}
                                     md={12}
                                     sm={12}
                                     xs={12}
                                     pt={2}
                                     alignContent={"center"}
                                   >
                                     <Typography className={classes.cardTitle}>
                                       Company / School / Person Information
                                     </Typography>
                                   </Grid>
                                 </Grid>
               

                <Grid item lg={12} md={10} sm={12} xs={12} py={2}>
                      <Grid container spacing={3} p={"24px"}>
                    
                       <Grid item lg={6} md={6} sm={12} xs={12}>
                                     <Grid container alignItems="center">
                                       <Grid item lg={12} md={12} sm={12} xs={12}>
                                         <Typography variant="subtitle1">
                                          Name <span style={{ color: "red" }}>*</span>
                                         </Typography>
                                       </Grid>
                                       <Grid item lg={12} md={12} sm={12} xs={12}>
                                         <TextField
                                           placeholder="Enter First Name"
                                           size="small"
                                           {...formik.getFieldProps("customerFirstName")}
                                           className={classes.textField}
                                           InputProps={{
                                             sx: {
                                               fontSize: 14,
                                             },
                                           }}
                                           InputLabelProps={{
                                             sx: {
                                               fontSize: 14,
                                             },
                                           }}
                                            error={formik.touched.customerFirstName && Boolean(formik.errors.customerFirstName)}
   helperText={formik.touched.customerFirstName && formik.errors.customerFirstName}
                                         />
                                       </Grid>
                                     </Grid>
                                   </Grid>
               


          {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Last Name</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Last Name"
                            size="small"
                            {...formik.getFieldProps("customerLastName")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid> */}
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Phone Number
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter Phone Number"
                            size="small"
                            {...formik.getFieldProps("customerMobileNum")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerMobileNum &&
                              Boolean(formik.errors.customerMobileNum)
                            }
                            helperText={
                              formik.touched.customerMobileNum &&
                              formik.errors.customerMobileNum
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">E-mail</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Enter E-mail"
                            size="small"
                            type="email"
                            {...formik.getFieldProps("customerEmail")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerEmail &&
                              Boolean(formik.errors.customerEmail)
                            }
                            helperText={
                              formik.touched.customerEmail &&
                              formik.errors.customerEmail
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>


 {/* <Grid item lg={12} md={12} sm={12} xs={12} >
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 1 }}
            
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle} 
                     >
                      Customer Address
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={3} pt={2}>

<Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Street No.
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Street No."
                          size="small"
                          {...formik.getFieldProps("customerStreetNumber")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Street Name
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Street Name"
                          size="small"
                          {...formik.getFieldProps("customerStreetName")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           City
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter City"
                          size="small"
                          {...formik.getFieldProps("customerCity")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Province
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Province"
                          size="small"
                          {...formik.getFieldProps("customerProvince")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">
                           Postal Code
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          placeholder="Enter Postal Code"
                          size="small"
                          {...formik.getFieldProps("customerPostalCode")}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
 </Grid>
 </Card>
 </Grid> */}







<Grid item lg={12} md={12} sm={12} xs={12}  >
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"} >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>
                  <Button
                    variant="contained"
                    startIcon={<SaveAltIcon />}
                    className={classes.addButton}
                    onClick={() => formik.handleSubmit()}
                    //disabled={!formValid || isLoading}
                      disabled={isLoading}
                  >
                    Save
                  </Button>
                </Grid>
                </Grid>
                </Card>
                </Grid>

              </Grid>
              </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Dialog>
    </form>
  );
};

export default Customer;
